// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { DBTable } from '../../../../../com/MetaPattern/MDA/MD/DBModel/DBTable';
/**
 * 数据库行 实体类
 * 数据库行
 */
export class DBRow extends BaseEntity {
  /** 数据库表 的ID */
  private _table_ID: string;

  /** 获取：数据库表 的ID */
  public get table_ID() {
    return this._table_ID;
  }

  /** 设置：数据库表 的ID */
  public set table_ID(value: string) {
    this._table_ID = value;
  }

  /** 数据库表  */
  private _table: DBTable;

  /** 获取：数据库表  */
  public get table() {
    return this._table;
  }

  /** 设置：数据库表  */
  public set table(value: DBTable) {
    this._table = value;
    if (value !== null) {
      this.table_ID = value.id;
    } else {
      this.table_ID = '';
    }
  }

  constructor() {
    super();
    this._table_ID = '';
    this._table = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: DBRow, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.table_ID = element.table_ID;
      if (hasReference && element.table !== null) {
        this.table = element.table;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.table_ID = json.Table_ID;
    // if (json.Table !== null) {
    //   this.table = DBTable.Create(json.Table);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Table_ID = this.table_ID;
  }

  static Create(json: any): DBRow {
    const dBRow = new DBRow();
    dBRow.Deserialize(json);
    dBRow.json = json;
    return dBRow;
  }
}
